import React from 'react';
import { css } from '@emotion/react';
import t from 'react-translate';

import { config } from '@config/pendo.config.json';
import { gray1 } from 'styles/global_defaults/colors';
import { normalFontWeight, openSans, semiBoldFontWeight, textMediumLineHeight, textSmallFontSize } from 'styles/global_defaults/fonts';
import { halfSpacing, quarterSpacing } from 'styles/global_defaults/scaffolding';

type Props = {
  message?: string;
};

const styles = css`
  padding: ${halfSpacing}px 0;
  font-family: ${openSans};
  font-weight: ${normalFontWeight};
  font-size: ${textSmallFontSize}px;
  line-height: ${textMediumLineHeight}px;
  color: ${gray1};

  .bottom-note-label {
    font-weight: ${semiBoldFontWeight};
    margin-right: ${quarterSpacing}px;
  }
`;

const BottomNote: React.FC<Props> = ({ message }) => {
  if (!message) {
    return null;
  }

  return (
    <div css={styles} data-qa={config.pendo.submissionView.aiInsights.bottomNote}>
      <span className='bottom-note-label'>
        {t.SUBMISSIONS.AI_ASSIGNMENT.BOTTOM_NOTE()}:
      </span>
      {message}
    </div>
  );
};

export default BottomNote;
